module.exports = __webpack_public_path__ + "img/US Map outline.3ee9b290.png";